const selectors = {
  chatTrigger: '[data-chat-trigger]',
};

// Set when a trigger is clicked before the widget finished loading, so the
// click can be replayed from the ready hook instead of being dropped.
let openQueued = false;

/**
 * True once the SalesIQ widget has installed its JS API.
 * @returns {boolean}
 */
function isWidgetReady() {
  return typeof window.$zoho?.salesiq?.floatwindow?.visible === 'function';
}

/**
 * Opens the SalesIQ float window, or queues the request when the widget has
 * not loaded yet.
 */
function openChat() {
  if (isWidgetReady()) {
    window.$zoho.salesiq.floatwindow.visible('show');
    return;
  }

  openQueued = true;
}

/**
 * Installs our callback on $zoho.salesiq.ready, preserving any callback that
 * was already registered.
 *
 * snippets/zoho-salesiq.liquid seeds $zoho.salesiq with a no-op ready before
 * this runs, and the widget script (#zsiqscript, deferred) calls ready once its
 * API is available.
 */
function hookWidgetReady() {
  window.$zoho = window.$zoho || {};
  window.$zoho.salesiq = window.$zoho.salesiq || {};

  const previousReady = window.$zoho.salesiq.ready;

  window.$zoho.salesiq.ready = function ready(...args) {
    if (typeof previousReady === 'function') {
      previousReady.apply(this, args);
    }

    if (openQueued) {
      openQueued = false;
      openChat();
    }
  };
}

/**
 * Wires [data-chat-trigger] buttons (snippets/chat-card.liquid, rendered by the
 * chat-block theme block) to the Zoho SalesIQ float window.
 *
 * Behavior:
 *   - Clicks before the widget loads are queued and replayed on ready, so an
 *     early click is not silently dropped.
 *   - Zoho's own float button is left alone; this is an additional entry point.
 *
 * Listens on document rather than binding each trigger, because chat-block is a
 * theme block and the editor re-renders its section markup on every setting
 * change, which would drop per-element listeners.
 */
export default function initChat() {
  hookWidgetReady();

  document.addEventListener('click', event => {
    const trigger = event.target.closest(selectors.chatTrigger);

    if (!trigger) {
      return;
    }

    event.preventDefault();
    openChat();
  });
}
